import React from 'react';

export const Checkbox: React.FC = (): JSX.Element => {
  return (
    <label className="checkbox">
      <input type="checkbox" className="checkbox__control" />
      <div className="checkbox__overlay" />
    </label>
  );
};
